<ng-container *transloco="let t">
  {{ t('GENERIC_WRAPPER.NO_PASSES') }}
</ng-container>
